if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        console.log('PRODUCT FORM JS IS RUNNING');
        console.log('SUBMITTED FORM ID BEFORE FORCE:', formData.get('id'));
        console.log('GLOBAL OTM VARIANT:', window.OTM_CURRENT_VARIANT_ID);

        if (window.OTM_CURRENT_VARIANT_ID) {
          formData.set('id', window.OTM_CURRENT_VARIANT_ID);

          const idInput = this.form.querySelector('[name="id"]');
          if (idInput) {
            idInput.value = window.OTM_CURRENT_VARIANT_ID;
            idInput.setAttribute('value', window.OTM_CURRENT_VARIANT_ID);
          }

          console.log('FORCED CART VARIANT ID:', window.OTM_CURRENT_VARIANT_ID);
        }

        // --- OTM / Westloft print fulfilment properties ---
        const selectedVariantId = String(formData.get('id'));

        const sizeMap = {
          Minima: 'A4 | 21 × 29.7 cm',
          Medium: 'A3 | 29.7 × 42 cm',
          Maxima: 'A2 | 42 × 59.4 cm',
          Grand: 'A1 | 59.4 × 84.1 cm'
        };

        try {
          const productResponse = await fetch(`${window.location.pathname}.js`);
          const productData = await productResponse.json();

          const selectedVariant = productData.variants.find((variant) => {
            return String(variant.id) === selectedVariantId;
          });

          if (selectedVariant && selectedVariant.options) {
            const selectedOptions = selectedVariant.options.map((option) => option.trim());

            const finish = selectedOptions.find((value) =>
              ['Print Only', 'Museum Framed'].includes(value)
            );

            const sizeName = selectedOptions.find((value) =>
              ['Minima', 'Medium', 'Maxima', 'Grand'].includes(value)
            );

            const frameFinish = selectedOptions.find((value) =>
              [
                'Black Wood',
                'White Wood',
                'Natural Oak',
                'Dark Walnut',
                'Gold',
                'Antique Style Baroque Black',
                'Antique Style Baroque Gold'
              ].includes(value)
            );

            if (finish) {
              formData.append('properties[Finish]', finish);
            }

            if (sizeName && sizeMap[sizeName]) {
              formData.append('properties[Format]', `${sizeName} (${sizeMap[sizeName]})`);
            }

            if (finish !== 'Print Only' && frameFinish) {
              formData.append('properties[Frame Finish]', frameFinish);
            }

            console.log('FULFILMENT OPTIONS:', {
              finish,
              sizeName,
              frameFinish,
              printSize: sizeName && sizeMap[sizeName] ? `${sizeName} (${sizeMap[sizeName]})` : null
            });
          }
        } catch (error) {
          console.error('Could not add print fulfilment properties:', error);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');

              this.error = true;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }

            this.error = false;

            CartPerformance.measure('add:paint-updated-sections', () => {
              this.updateCartSilently(response);
              this.showCartSuccess(response);
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      updateCartSilently(response) {
        if (!this.cart || !response.sections) return;

        this.cart.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);

          if (!sectionElement || !response.sections[section.id]) return;

          const parsedHTML = new DOMParser().parseFromString(
            response.sections[section.id],
            'text/html'
          );

          const newSection = parsedHTML.getElementById(section.id);

          if (newSection) {
            sectionElement.innerHTML = newSection.innerHTML;
          }
        });
      }

      showCartSuccess(response) {
        const existingMessage = this.form.querySelector('.otm-cart-success');

        if (existingMessage) {
          existingMessage.remove();
        }

        const productTitle =
          document.querySelector('.product__title h1')?.textContent?.trim() ||
          response.product_title ||
          response.title ||
          'this item';

        const successMessage = document.createElement('div');
        successMessage.className = 'otm-cart-success';

        successMessage.innerHTML = `
          You added <strong>${productTitle}</strong> to your
          <a href="/cart">shopping cart</a>.
        `;

        const addToCartButton =
          this.form.querySelector('[type="submit"]')?.closest('.product-form__buttons') ||
          this.submitButton;

        if (addToCartButton && addToCartButton.parentNode) {
          addToCartButton.parentNode.insertBefore(successMessage, addToCartButton);
        } else {
          this.form.appendChild(successMessage);
        }

        requestAnimationFrame(() => {
          successMessage.classList.add('is-visible');
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}